import InviteEmployee from './InviteEmployee.component';

export default InviteEmployee;
